import React from 'react';
import { connect } from 'react-redux';
import IndexTableRow from '../../../shared/index/table_row';
import ContentTitleCell from './cells/title';
import LastModifiedCell from '../../../shared/index/last_modified_cell';
import {
  AverageScoreCell,
  CompletedCountCell,
  LastCompletedCell,
  LastActivityCell,
  FreshnessScoreCell,
} from './cells/stats_cells';
import StateCell from './cells/state';

const renderStatisticsCells = ({ selectedContentType, stats }) => {
  if (selectedContentType === 'fresh_content') {
    return [
      <LastActivityCell key="last-activity-cell" {...stats} />,
      <FreshnessScoreCell key="freshness-score-cell" {...stats} />,
    ];
  }

  return [
    <AverageScoreCell
      key="average-score-cell"
      averageScore={stats.averageScore}
    />,
    <CompletedCountCell key="completed-count-cell" {...stats} />,
    <LastCompletedCell key="last-completed-cell" {...stats} />,
  ];
};

const ContentRow = props => (
  <IndexTableRow
    index={props.index}
    checkBoxDisabled={props.type === 'practice/container' || !props.urls.edit}
  >
    <ContentTitleCell {...props} selected={undefined} />
    <StateCell
      state={props.displayedState}
      scorm={props.scorm}
      versionNumber={props.version_number}
      hasScormVersionsFeature={props.features.scorm_versions_editing}
      type={props.type}
    />
    <LastModifiedCell lastModified={props.lastModified} />
    {renderStatisticsCells(props)}
  </IndexTableRow>
);

const mapStateToProps = ({ data }) => ({
  features: {
    scorm_versions_editing: data.meta.features.scorm_versions_editing,
  },
});

export default connect(mapStateToProps)(ContentRow);
